const getSwiperOptions = (hasMultipleSlides: boolean) => ({
    slidesPerView: 1,
    spaceBetween: 0,
    freeMode: {enabled: false},
    breakpoints: {0: {slidesOffsetBefore: 0, slidesOffsetAfter: 0}},
    ...(hasMultipleSlides && {
        pagination: {clickable: true, el: undefined},
    }),
});

export default getSwiperOptions;
